export enum RequestCreationType {
    CREATED_BY_CLIENT = 'CREATED_BY_CLIENT',
    CREATED_BY_ADMIN = 'CREATED_BY_ADMIN',
}
